<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import Navbar from '@/components/Navbar.vue'

const authStore = useAuthStore()
</script>

<template>
  <div class="min-h-screen">
    <Navbar v-if="authStore.isAuthenticated" />
    <main class="container mx-auto px-4 py-8">
      <RouterView />
    </main>
  </div>
</template>
